const messages = {
  langname: 'Polski',
  label: {
    language: 'Język',
    me: 'Ja',
    ok: 'OK',
    end: 'Koniec',
    exit: 'Wyjdź',
    cancel: 'Anuluj',
    close: 'Zamknij',
    clear: 'Wyczyść',
    error: 'Błąd',
    filter: 'Filtruj',
    search: 'Szukaj',
    notfound: 'Nic nie znaleziono',
    duplicate: 'Powiel',
    copy: 'Kopiuj',
    paste: 'Wklej',
    move: 'Przenieś',
    reorder: 'Zmień kolejność',
    new: 'Nowy',
    create: 'Utwórz',
    add: 'Dodaj',
    delete: 'Usuń',
    deleteConfirm: 'Potwierdź usunięcie',
    trash: 'Kosz',
    erase: 'Wykasuj',
    restore: 'Przywróć',
    hide: 'Ukryj',
    show: 'Pokaż',
    share: 'Udostępnij',
    more: 'Więcej',
    preview: 'Podgląd',
    settings: 'Ustawienia',
    dashboard: 'Sterowanie',
    edit: 'Edytuj',
    select: 'Wybierz',
    all: 'Wszystko',
    done: 'Gotowe',
    save: 'Zapisz',
    saving: 'Zapisywanie...',
    savingError: 'Błąd zapisu!',
    send: 'Wyślij',
    files: 'Pliki',
    download: 'Pobierz',
    off: 'Wył.',
    on: 'Wł.',
    nolimit: 'Bez limitu',
    start: 'Start',
    stop: 'Stop',
    resume: 'Wznów',
    back: 'Wstecz',
    next: 'Dalej',
    true: 'Prawda',
    false: 'Fałsz',
    schedule: 'Zaplanuj',
    days: 'dni',
    hours: 'godziny',
    minutes: 'minuty',
    seconds: 'sekundy',
    today: 'dzisiaj',
    yesterday: 'wczoraj'
  },
  auth: {
    consent: {
      text: 'Logując się akceptujesz {terms} i {privacy} serwisu {home}',
      terms: 'regulamin',
      privacy: 'politykę prywatności'
    },
    title: {
      signin: 'Logowanie',
      create: 'Nowe konto'
    },
    email: {
      label: 'Email'
    },
    password: {
      label: 'Hasło'
    },
    code: {
      label: 'Kod wysłany na Twój email'
    }
  },
  account: {
    signout: 'Wyloguj',
    id: 'Identyfikator konta',
    setup: {
      info: 'Konfiguracja konta {step}',
      profile: {
        title: 'Wybierz profil główny',
        info: 'Możesz go zmienić później'
      },
      name: {
        title: 'Podaj swoją nazwę użytkownika',
        info: 'Będzie ona widoczna dla innych użytkowników'
      }
    },
    switch: {
      attendee: 'Strefa słuchacza',
      presenter: 'Strefa prezentera',
      settings: 'Ustawienia konta',
      add: 'Dodaj konto'
    },
    avatar: {
      add: 'Dodaj zdjęcie',
      del: 'Usuń zdjęcie'
    },
    name: {
      title: 'Nazwa',
      none: 'Brak nazwy'
    },
    email: {
      title: 'Email'
    },
    password: {
      title: 'Logowanie hasłem',
      input: 'Nowe hasło'
    },
    menu: {
      title: 'Profil główny',
      ATTENDEE: 'Słuchacz',
      PRESENTER: 'Prezenter'
    },
    delete: {
      input: 'Usuń konto',
      confirm: {
        title: 'Potwierdź usunięcie konta',
        subtitle: 'Wszystkie dane zostaną bezpowrotnie wykasowane'
      }
    }
  },
  contact: {
    title: 'Kontakty',
    empty: 'Brak kontaktów',
    identity: 'Kontakt ID',
    select: 'Pokaż wybrane grupy',
    notfound: 'Brak konta',
    deleted: 'Konto usunięte',
    err: 'Kontakt ID jest już zajęty',
    groups: {
      btn: 'Grupy',
      empty: 'Brak grup',
      name: 'Nazwa grupy',
      err: 'Grupa o tej nazwie już istnieje',
      delete: 'Usunięcie grupy nie usuwa kontaktów'
    },
    import: {
      title: 'Importuj kontakty',
      placeholder: 'Kontakt ID ; adres@email.pl ; Grupa #1 ; Grupa #2 ; ...',
      btnfile: 'Wczytaj plik CSV',
      btn: 'Importuj',
      result: {
        correct: 'Zaimportowano',
        found: 'Nowe kontakty',
        groups: 'Nowe grupy',
        notfound: 'Brak kont',
        wrong: 'Pominięto',
        duplicates: 'Duplikaty',
        errors: 'Błędy'
      }
    }
  },
  attendee: {
    guest: {
      label: 'Gość',
      signin: 'Kontynuuj jako gość',
      wronglink: 'Błędny link sesji'
    },
    home: {
      signup: 'Posiadasz kod zapisu?',
    },
    signup: {
      btn: 'Zapisz się',
      code: 'Kod zapisu'
    },
    course : {
      empty: 'Brak dostępnych tematów'
    },
    topic: {
      retake: 'Powtórz'
    },
    session: {
      start: 'Zacznij teraz',
      notstarted: 'Oczekiwanie na start sesji',
      ended: 'Sesja zakończona',
      finish: {
        btn: 'Zakończ',
        confirm: {
          title: 'Zakończyć udzielanie odpowiedzi?',
          subtitle: 'Po zakończeniu sesji nie będzie już można wrócić do udzialania odpowiedzi'
        }
      }
    }
  },
  activity: {
    today: 'Dziś',
    tomorrow: 'Jutro',
    soon: 'Wkrótce',
    sessions: {
      title: 'Zaplanowane sesje',
      start: 'Start',
      end: 'Koniec',
      empty: 'Brak wydarzeń w tym tygodniu'
    },
    posts: {
      title: 'Aktywność na forum',
      empty: 'Brak wpisów z ostatnich 30 dni'
    }
  },
  search: {
    person: 'Nazwa, email',
    hint: 'Wprowadź przynajmniej dwa znaki',
    noitems: 'Nic nie znaleziono'
  },
  trash: {
    info: 'Rzeczy w koszu są przechowywane przez 30 dni od daty ich usunięcia',
    noitems: 'Kosz jest pusty',
    empty: 'Opróżnij kosz',
    confirmempty: 'Wykasować bezpowrotnie wszystkie rzeczy z kosza?',
    confirmitem: 'Wykasować bezpowrotnie?'
  },
  item: {
    menu: {
      folder: 'Zawartość',
      course: 'Tematy',
      topic: 'Slajdy',
      team: 'Zespół',
      attendees: 'Uczestnicy',
      sessions: 'Sesje',
      forum: 'Forum',
      rate: 'Oceń kurs'
    },
    edit: {
      move: 'Przenieś do',
      copy: 'Powiel do',
      name: {
        placeholder: 'Nowa nazwa',
        err: 'Nazwa nie może być pusta!'
      },
      info: {
        placeholder: 'Napisz kilka słów'
      },
      image: {
        select: 'Podaj link do obrazka lub wybierz obrazek z katalogu',
        title: 'Okładka'
      },
      files: {
        select: 'Podaj link do pliku lub wybierz plik z katalogu',
        name: 'Nazwa',
        hide: 'Ukryj przed uczestnikami',
        del: 'Usunąć załącznik?'
      }
    },
    publish: {
      on: 'Udostępnij uczestnikom',
      off: 'Ukryj przed uczestnikami'
    },
    home: {
      name: 'Katalog główny',
      title: 'Twoje projekty',
      courses: 'Kursy',
      quizzes: 'Quizy',
      keynotes: 'Prezentacje'
    },
    folder: {
      add: 'Nowy folder',
      name: 'Nowy folder',
      empty: 'Folder jest pusty'
    },
    course: {
      add: 'Nowy kurs',
      name: 'Nowy kurs',
      info: 'Informacje o kursie',
      empty: 'Brak tematów',
      gradebook: {
        settings: 'Dziennik ocen',
        result: 'Wynik',
        weight: {
          title: 'Waga tematu w ocenie'
        },
        retakes: {
          title: 'Wynik do oceny',
          info: 'W przypadku wielu podejść uwzględnij',
          first: 'Pierwszy wynik',
          last: 'Ostatni wynik',
          avg: 'Uśrednij wyniki',
          max: 'Najlepszy wynik'
        }
      }
    },
    topic: {
      add: 'Nowy temat lub prezentacja',
      name: 'Nazwa',
      info: 'Informacje',
      empty: 'Brak slajdów'
    },
    quiz: {
      add: 'Nowy quiz lub zadanie',
      name: 'Nazwa'
    }
  },
  slides: {
    select: {
      title: 'Zaznaczenie',
      all: 'Wybierz wszystkie',
      none: 'Odznacz wszystkie',
      inverse: 'Odwróć wybór'
    },
    timer: 'Limit czasu',
    group: {
      title: 'Przypisz do grupy',
      off: 'Bez grupy',
      merge: 'Połącz kolejne slajdy grupy w jeden',
      shuffle: 'Mieszaj grupę z innymi slajdami i grupami',
      count: 'Limit mieszanych slajdów w grupie'
    },
    add: {
      btn: 'Dodaj slajd lub pytanie',
      keynote: 'Elementy prezentacji',
      quiz: 'Pytania testowe',
      poll: 'Pytania ankietowe',
      clipboard: 'Wklej ze schowka',
      pasteall: 'Wklej wszystko',
      slide: 'Slajd',
      image: 'Link/Plik',
      movie: 'Film',
      choice: 'Wybór',
      yesno: 'Prawda/Fałsz',
      order: 'Kolejność',
      number: 'Liczba',
      gaps: 'Puste pola',
      essay: 'Esej',
      vote: 'Głosowanie',
      rate: 'Ocena',
      open: 'Otwarte'
    },
    edit: {
      copy: 'Skopiowano do schowka',
      delete: 'Usuwając slajd stracisz dostęp do danych uczestników sesji powiązanych z tym slajdem. Tej operacji nie można cofnąć.',
      notes: 'Notaki prezentera',
      image: {
        url: 'Podaj link lub wybierz plik z katalogu',
        supported: ''
      },
      movie: {
        url: 'Adres URL (YouTube lub Vimeo)'
      },
      choice: {
        correct: 'Określ prawidłowe odpowiedzi',
        multi: 'Pytanie wielokrotnego wyboru',
        tails: {
          title: 'Kafelkowy układ odpowiedzi',
          sm: 'Kafelki małe',
          md: 'Kafelki średnie',
          lg: 'Kafelki duże'
        }
      },
      yesno: {
        correct: 'Określ wyrażenia pozytywne',
        label: {
          positive: 'Etykieta pozytywna',
          negative: 'Etykieta negatywna'
        }
      },
      order: {
        correct: 'Określ pierwszą z nieistotnych odpowiedzi (jeżeli takie są)',
        info1: 'Odpowiedzi będą wyświetlane uczestnikom w losowej kolejności'
      },
      number: {
        correct: 'Wprowadź prawidłową odpowiedź'
      },
      gaps: {
        correct: 'Wprowadź tekst z pustymi polami',
        dropdown: {
          title: 'Wybór odpowiedzi z listy',
          info: 'W miejscu na odpowiedź wyświetlana będzie lista rozwijana z wszystkimi prawidłowymi odpowiedziami jakie zostały zdefiniowane w treści pytania. Odpowiedzi będą wyświetlane w kolejności alfabetycznej.'
        },
        selects: {
          title: 'Każda luka ma własną listę',
          info: 'W miejscu na odpowiedź wyświetlana będzie lista rozwijana z wszystkimi odpowiedziami jakie zostały zdefiniowane dla danej luki. Odpowiedzi będą wyświetlane w kolejności alfabetycznej. Wyłącznie pierwsza zdefiniowana odpowiedź jest traktowana jako prawidłowa.'
        },
        case: 'Uwzględniaj wielkość liter',
        diacritics: 'Ignoruj różnice diakrytyczne (ogonki)',
        info1: 'Tam gdzie chcesz aby w zdaniu utworzone zostało puste pole na udzielenie odpowiedzi wstaw treść prawidłowej odpowiedzi w podwójnych nawiasach kwadratowych. Jeżeli możliwa jest więcej niż jedna prawidłowa odpowiedź, poszczególne opcje rozdziel znakiem ukośnika. Aby określić odpowiedź pustą jako prawidłową użyj znaku minusa (uczestnicy aby udzielić pustej odpowiedzi powinni również użyć znaku minusa). Zobacz poniższy przykład:',
        example1: 'Tam gdzie [[jest]] gorąco, tam [[są/żyją]] żyrafy i [[-]] słonie.',
        info2: 'Uwaga! Zmiana kolejności zdefiniowanych pustych pól spowoduje nieprawidłowe dopasowenie zebranych do tej pory odpowiedzi. Bezpieczna forma modyfikacji pytania to taka, która nie zmienia kolejności występowania istniejących już pustych pól lub dodaje nowe puste pola za już istniejącymi.'
      },
      essay: {
        textinfo: 'Pole na udzielenie odpowiedzi otwartej zostanie ukryte',
        fileinfo: 'Pole na załączenie pliku zostanie ukryte'
      },
      vote: {
        multi: 'Pytanie wielokrotnego wyboru',
        multimax: 'Maksymalna liczba wyborów'
      },
      rate: {
        option: 'Wariant pytania',
        stars5: 'Gwiazdki 1 - 5',
        scale1to10: 'Skala 1 - 10',
        scale0to10: 'Skala 0 - 10',
        slider100: 'Suwak 0 - 100',
        label: {
          min: 'etykieta minimum',
          max: 'etykieta maksimum'
        }
      },
      open: {
        textlimit: 'Limit wprowadzonych znaków',
        filelimit: 'Limit wielkości plików [MB]'
      },
      params: {
        x: 'Parametry pytań',
        y: 'Prawidłowe odpowiedzi',
        add: 'Nowy zestaw losowy',
        delete: {
          all: 'Usunięcie losowych parametrów skutkuje cofnięciem przyznanych za to pytanie punktów wszystkim uczestnikom. Tej operacji nie można cofnąć.',
          row: 'Usunięcie zestawu losowego skutkuje cofnięciem przyznanych za to pytania punktów tym uczestnikom, którzy wylosowali ten zestaw. Tej operacji nie można cofnąć.'
        },
        use: 'Losowe parametry'
      },
      answers: {
        add: {
          answer: 'Nowa odpowiedź',
          statement: 'Nowe zdanie'
        },
        delete: 'Usuwając odpowiedź stracisz dane uczestników sesji powiązane z tą odpowiedzią. Tej operacji nie można cofnąć.',
        enter: 'ENTER dodaje nową odpowiedź',
        ctrlenter: 'CTRL/CMD + ENTER dodaje nową odpowiedź',
        multi: 'Dodaje każdą linię jako oddzielną odpowiedź',
        randomize: {
          on: 'Pomieszaj odpowiedzi',
          off: 'Nie mieszaj odpowiedzi',
          lastoff: 'Nie mieszaj ostatniej odpowiedzi'
        }
      },
      points: {
        all: {
          correct: 'Punkty za prawidłową odpowiedź',
          wrong: 'Punkty za błędną odpowiedź'
        },
        each: {
          correct: 'Punkty za każdą prawidłową odpowiedź',
          wrong: 'Punkty za każdą błędną odpowiedź'
        },
        toggle: 'Licz punkty dla każdej odpowiedzi'
      }
    }
  },
  team: {
    owner: 'Właściciel',
    empty: 'Brak osób w zespole',
    add: 'Dodaj do zespołu',
    role: {
      title: 'Ustaw uprawnienia',
      PRESENTER: 'Prezenter',
      EDITOR: 'Koordynator',
      ADMIN: 'Administrator'
    }
  },
  attendees: {
    empty: 'Brak uczestników',
    emptyinfo: 'Przekaż uczestnikom kod zapisu albo kliknij przycisk plusa aby wyszukać i dodać uczestników lub utworzyć grupę',
    add: 'Dodaj uczestnika',
    block: {
      on: 'Zablokować uczestnika?',
      off: 'Odblokować uczestnika?'
    },
    code: {
      show: 'Kod zapisu',
      copy: 'Kopiuj kod',
      link: 'Kopiuj link',
      qr: 'Pobierz qr-code',
      renew: 'Generuj nowy'
    },
    groups: {
      all: 'Wszyscy',
      not: 'Bez grupy',
      edit: {
        add: 'Utwórz grupę',
        placeholder: 'Nazwa grupy',
        err: 'Nazwa grupy jest wymagana!'
      },
      change: 'Zmień grupę'
    },
    result: {
      show: {
        all: 'Pokaż wszystko',
        errors: 'Pokaż błędy'
      }
    }
  },
  sessions: {
    empty: 'Brak sesji',
    notstarted: 'Brak czasu rozpoczęcia',
    add: {
      title: 'Utwórz nową sesję',
      private: 'Sesja prywatna (wymagany kod zapisu)',
      all: 'Sesja otwarta (wszyscy uczestnicy)',
      group: 'Sesja dla grupy ({name})'
    },
    manager: {
      action: {
        leave: 'Opuść sesję',
        end: 'Zakończ sesję',
        start: 'Początek sesji',
        stop: 'Koniec sesji',
        slides: 'Prezentacja',
        projector: 'Pokaz na projektorze',
        results: 'Pokaż wyniki (LIVE)',
        check: 'Sprawdź odpowiedź'
      },
      confirm: {
        start: 'Zacząć sesję teraz?',
        startError: 'Data startu z przeszłości!',
        stop: 'Zakończyć sesję teraz?',
        stopError: 'Data zakończenie sprzed daty startu!'
      },
      chat: {
        inputOff: 'Chat wyłączony'
      },
      settings: {
        show: {
          code: 'Pokaż kod zapisu',
          leader: 'Pokaż tabelę wyników'
        },
        forward: {
          title: 'Nawigacja pytanie po pytaniu',
          info: 'Nawiguj zawsze do kolejnego pytania, bez możliwości powrotu.'
        },
        result: {
          title: 'Pokaż wynik podsumuwający na koniec',
          info: 'Pokaż czas odpowiedzi i liczbę zdobytych punktów po zakończeniu odpowiedzi.'
        },
        feedback: {
          title: 'Pokazuj rozwiązania i wyniki ankiet',
          info: 'Pokazuj prawidłowe rozwiązania oraz wyniki ankiet dla poszczególnych pytań po zakończeniu odpowiedzi.'
        },
        share: {
          title: 'Udostępnij slajdy na koniec',
          info: 'Uczestnicy, po zakończeniu sesji, będą mieli dostęp do treści slajdów.'
        },
        time: {
          title: 'Limit czasu',
          info: 'Maksymalny czas na udzielanie odpowiedzi liczony od momentu rozpoczęcia quizu.'
        },
        retakes: {
          title: 'Poprawki',
          info: 'Liczba dozwolonych podejść do quizu (po pierwszym podejściu).'
        }
      }
    }
  },
  messenger: {
    title: 'Wiadomości',
    empty: 'Brak wiadomości',
    input: 'Nowa wiadomość',
    btn: 'Klawiatura: CTRL/CMD + ENTER'
  },
  forum: {
    empty: 'Brak tematów',
    posts: 'Wpisów: {total}',
    last: 'Ostatni: {date}',
    trash: 'Tematy usunięte',
    deleted: 'Usunięto: {date}',
    edit: {
      name: 'Nazwa tematu',
      info: 'Opis tematu',
      readonly: 'Uczestnicy mogą tylko czytać',
      reverse: 'Najnowsze wpisy na górze',
      groups: 'Ogranicz dostęp do uczestników wybranych grup',
      nogroups: 'Brak grup'
    },
    post: {
      empty: 'Brak wpisów',
      add: 'Nowy wpis',
      edit: 'Edycja wpisu',
      edited: 'Edycja: {date}',
      hidden: 'Wpis ukryty przez moderatora forum'
    }
  },
  rate: {}
}

const numberFormats = {
  currency: {
    style: 'currency',
    currency: 'PLN'
  }
}

const dateTimeFormats = {
  short: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  normal: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', weekday: 'short', hour: 'numeric', minute: 'numeric'
  }
}

import quasar from 'quasar/lang/pl'

export default {
  quasar,
  messages,
  numberFormats,
  dateTimeFormats
}
